






































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import L, { LatLng } from 'leaflet';
import { Listing } from '../models/Listing';
import ListingUtil from '../utils/ListingUtil';
import { ListingDetail } from '@/models/ListingDetail';

@Component
export default class PopupSingleListing extends Vue {

    public showPopup: boolean = false;
    public popup: L.Popup | null = null;

    public daysOnMarket: number | string = '';
    public price: string = '';
    public isImgLoaded: boolean = false;
    public isSold: boolean = false;
    public lastFeatureId: number = -1;
    public lastLatLon: L.LatLng = new LatLng(0, 0);

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'singleListingSelectedViaMap') {
            console.log('singleListingSelectedViaMap');
            this.onSingleListingSelected(action.payload);
        }
        if (action.type === 'popupSingleListing') {
            this.onPopupFromListing(action.payload.listing, action.payload.latLng);
        }
        if (action.type === 'closePopups') {
            this.closePopup();
        }
    });

    get map(): L.Map {
        return this.$store.state.map;
    }

    get config() {
        return this.$store.state.config;
    }

    get leftDrawerOpen() {
        return this.$store.state.leftDrawerOpen;
    }

    get isLoggedIn() {
        return this.$store.state.isLoggedIn;
    }

    get selectedListing() {
        return this.$store.state.listings.selectedListing;
    }

    
    get selectedListingDetail(): ListingDetail {
        return this.$store.state.listings.selectedListingDetail;
    }

    get isFullListingDetailsAvailable() {
        return this.isLoggedIn || this.selectedListing.st !== '2';
    }


    get imageSrc(): string {
        // TODO: need an optimized image for these popups
        // let img = ListingUtil.addMapPostfixToImage(this.config.imageRoot + this.selectedListing.pi);
        let img = this.config.imageRoot + this.selectedListing.pi;
        if (!this.selectedListing.pi) {

            img = this.config.imageRoot + this.config.placeholdListingImg;
        } else if (this.selectedListing.pi.startsWith('?')) {
            // img = ListingUtil.addMapPostfixToImage(this.config.imageRoot + this.selectedListing.sid + '.jpg');
            img = this.config.imageRoot + this.selectedListing.sid + '.jpg';
        } else if (this.selectedListing.pi === (this.config.imageRoot + this.config.placeholdListingImg)) {
            img = this.config.imageRoot + this.config.placeholdListingImg;
        }

        return img;
    }

    get isFavourite() {
        if (this.selectedListing && this.$store.state.favourites.favouriteIds.indexOf(this.selectedListing.sid) !== -1) {
            return true;
        }
        return false;
    }

    public onImageLoad() {
        this.isImgLoaded = true;
    }

    public onViewDetails() {
        if (!this.isFullListingDetailsAvailable) {
            this.$store.dispatch('showLoginPromptDialog', 'You must login to view details of sold listings.');
        } else {
            this.$store.dispatch('showListingDialog');
        }
    }

    public closePopup() {
        if (this.popup) {
            this.map.closePopup(this.popup);
        }

        this.showPopup = false;
    }

    public onViewPhotos() {
        if (this.isFullListingDetailsAvailable) {
            this.$store.dispatch('setSelectedListing', this.selectedListing);
            this.$store.dispatch('showListingDialogPhotos');
        } else {
            this.$store.dispatch('showLoginPromptDialog', 'You must login to view details of sold listings.');
        }
    }

    public onToggleFavorite() {
        if (this.selectedListing) {
            if (!this.isLoggedIn) {
                this.$store.dispatch('showLoginPromptDialog', 'You must login to add to favourites.');
            } else {
                if (this.isFavourite) {
                    this.$store.dispatch('favouriteRemove',  this.selectedListing.sid);
                } else {
                    this.$store.dispatch('favouriteAdd', this.selectedListing.sid);
                }
            }
        }
    }

    public onSingleListingSelected(layer: L.Layer) {
        // Logger.writeLog("PopupMgr:_onSingleListingSelected");
        console.log('PopupMgr:_onSingleListingSelected');

        // @ts-ignore - its an esri layer
        const listingFeature = layer.feature;

        if (this.lastFeatureId === listingFeature.properties.OBJECTID) {
            this.openPopup(this.lastLatLon);
            return;
        }

        this.lastFeatureId = listingFeature.properties.OBJECTID;

        this.isImgLoaded = false;
        this.showPopup = false;
        const selectedListingMarkerPane = this.map.getPane('selectedListing');
        if (selectedListingMarkerPane) {
            selectedListingMarkerPane.style.display = 'block';
        }

        // if (this.$q.platform.is.desktop && this.leftDrawerOpen) {
        //     return;
        // }

        this.showPopup = true;

        // hide the marker so it doesn't get in the way of the popup
        if (selectedListingMarkerPane) {
            selectedListingMarkerPane.style.display = 'block';
        }
        this.price = ListingUtil.getListingPriceBasedOnStatus(listingFeature.properties.st,
        listingFeature.properties.sp, listingFeature.properties.lpmn, listingFeature.properties.cl, this.isLoggedIn);

        this.daysOnMarket = ListingUtil.getDaysOnMarket(listingFeature.properties.ld, listingFeature.properties.st, listingFeature.properties.fd);

        this.isSold = false;
        if (listingFeature.properties.st === '2' || listingFeature.properties.st === '2_0') {
            this.isSold = true;
        }
        let lLatlng = null;
        if (listingFeature.geometry.type === 'Polygon' || listingFeature.geometry.type === 'MultiPolygon') {
            // @ts-ignore - L.Polygon
            lLatlng = layer.getBounds().getCenter();
        } else {
            lLatlng = L.latLng(listingFeature.geometry.coordinates[1], listingFeature.geometry.coordinates[0]);
        }

        this.lastLatLon = lLatlng;
        this.openPopup(lLatlng);
    }

    // this is only invoked from query params on init
    public onPopupFromListing(listing: Listing, latLng: L.LatLng) {
        console.log('onPopupFromListing');

        this.isImgLoaded = false;
        this.showPopup = false;
        const selectedListingMarkerPane = this.map.getPane('selectedListing');
        if (selectedListingMarkerPane) {
            selectedListingMarkerPane.style.display = 'block';
        }

        this.showPopup = true;

        // hide the marker so it doesn't get in the way of the popup
        if (selectedListingMarkerPane) {
            selectedListingMarkerPane.style.display = 'block';
        }

        this.price = ListingUtil.getListingPriceBasedOnStatus(listing.st, listing.sp, listing.lpmn, listing.cl, this.isLoggedIn);

        this.daysOnMarket = ListingUtil.getDaysOnMarket(listing.ld, listing.st, listing.fd);

        this.isSold = false;
        if (listing.st === '2' || listing.st === '2_0') {
            this.isSold = true;
        }

        this.openPopup(latLng);
    }

    public openPopup(latLng: L.LatLng) {
        let popupWidth = 300;
        if (this.$q.platform.is.mobile) {
            popupWidth = 220;
        }

        this.popup = L.popup({
            className: 'singleListPopup',
            minWidth: popupWidth,
            maxWidth: popupWidth,
        })
        .setLatLng(latLng)
        .setContent(this.$el as HTMLElement)
        .openOn(this.map);
    }
}

